import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IChatboxV2PropsType } from '../../../../Routes/renderer/chatBoxV2'

interface IConfig extends Omit<IChatboxV2PropsType, 'type' | 'sendStoreId'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentCode: 'systemwide-salesmanship',
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      default:
        return defaultConfig
    }
  }, [brand])
}
